import React, { useState, useEffect } from 'react';
import LeadForm from '../Common/LeadForm';
import ABCDLeadForm from '../Common/ABCDLeadForm';
import { withTranslation } from 'react-i18next';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';

const StickyForm = (props) => {
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 200);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleToggleForm = () => {
    setIsFormVisible((prevIsFormVisible) => !prevIsFormVisible);
  };

  return (
    <div
      id="stickyJourneyForm"
      className={`${
        props?.rendering?.params?.IsDigiGold === '1'
          ? 'digi_gold_sticky sticky_form_button_wrapper sticky_form_open'
          : ''
      } stickyJourneyForm ${isFormVisible ? 'form-open show-form' : ''} ${
        isScrolled ? 'scroll-animation' : ''
      }`}
    >
      <div className={`collapse ${isFormVisible ? 'show' : ''}`} id="navbarToggleExternalContent">
        <div className="stckyCollapse-form">
          <div className="stickyJourneyForm_wrapper">
            <div className="start_journey_main_Wrapper homepage-banner">
              <div className="stickyJourneyForm_wrapper">
                <LeadForm props={props} />
                {}
                {}
              </div>
            </div>
          </div>
        </div>
      </div>
      <nav
        className={`navbar navbar-dark bg-dark sticky_form_button_wrapper ${
          isScrolled ? 'sticky_form_open' : ''
        }`}
      >
        <div className="container-fluid">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarToggleExternalContent"
            aria-controls="navbarToggleExternalContent"
            aria-expanded="true"
            aria-label="Toggle navigation"
            id="toggleButton-xx"
            onClick={handleToggleForm}
          >
            <div className="sticky_form_button">
              <img
                src="https://abconeprod.azureedge.net/dist/ABCD/assets/images/category/sticky_form.svg"
                alt="Buy Life Insurance"
                loading="lazy"
              />
              <span>{props?.fields?.StickyFormButtonText?.value}</span>
              <div className={`sticky_hamburger ${isFormVisible ? 'ham_clicked' : ''}`}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            </div>
          </button>
        </div>
      </nav>
    </div>
  );
};

export default withTranslation()(StickyForm);
